'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function AnimationWrapper({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  useEffect(() => {
    let cleanup: (() => void) | undefined;
    let cancelled = false;

    import('@/hooks/useGsapAnimations').then(({ ScrollAnimation }) => {
      if (!cancelled) {
        cleanup = ScrollAnimation();
      }
    });

    return () => {
      cancelled = true;
      cleanup?.();
    };
  }, [pathname]);

  return <>{children}</>;
}
